const iconList = [
  "Cog",
  "Dropdown",
  "Close",
  "Check",
  "Duplicate",
  "DoubleSkipRight",
  "Gantt",
  "Lines",
  "Grid",
  "DropdownSm",
  "Help",
  "AddUser",
  "Password",
  "DoubleSkipLeft",
  "Security",
  "Grid1",
  "Center",
  "Clock",
  "Tools",
  "NavRight",
  "Link",
  "Plane",
  "Timer",
  "Sort",
  "GoTo",
  "Export",
  "Trigger",
  "NavLeft",
  "Info2",
  "Add",
  "Email",
  "Star",
  "Notification",
  "User",
  "Timer1",
  "Severity",
  "Snapshot",
  "Play",
  "Loader",
  "Cloud",
  "NotificaationOff",
  "Search",
  "Filter",
  "Reset",
  "ZoomIn",
  "PictureInPicture",
  "AccordeonUp",
  "Folder",
  "Watchlist",
  "Expand",
  "Text",
  "Phone",
  "ZoonOut",
  "Remove",
  "EyeOffFill",
  "MapPin",
  "DoubleCheck",
  "Landing",
  "Plus",
  "Profile",
  "Alert",
  "NavDown",
  "Security2",
  "Bus",
  "AccordeonDown",
  "Takeoff",
  "Minus",
  "Trash",
  "SkipLeft",
  "NavUp",
  "SidebarRight",
  "Chart",
  "Info",
  "ArrowRight",
  "Options",
  "Date",
  "SkipRight",
  "CheckCircle",
  "SidebarLeft",
  "Return",
  "BallPenFill",
  "FileEditFill",
  "EditCircleFill",
  "Edit2Fill",
  "Configuration",
  "SpeedMini",
  "PlayMini",
  "Speed",
  "ListCheck",
  "ListSettingsLine",
  "PushpinFill",
  "SpamFill",
  "LockPasswordFill",
  "Lock2Fill",
  "LockUnlockFill",
  "EyeCloseLine",
  "LogoutBoxFill",
  "ArchiveFill",
  "ArchiveDrawerFill",
  "CheckboxCircleLine",
  "EyeFill",
  "BaselineRemoveRedEye",
  "Message3Fill",
  "Message2Fill",
  "LoopLeftFill",
  "LoopLeftLine",
  "UnpinFill",
  "ThumbUpFill",
  "ReplyFill",
  "SendPlaneFill",
  "LockFill",
  "Pushpin2Fill",
  "SortAsc",
  "SortDesc",
  "ArrowDropDownFill",
  "ArrowDropLeftFill",
  "ArrowDropRightFill",
  "ArrowDropUpFill",
  "ExpandUpDownLine",
  "Filter3Fill",
  "Flag2Fill",
  "MenuUnfoldFill",
  "Menu2Fill",
  "FlightTakeoffFill",
  "MenuFoldFill",
  "Airstairs1",
  "Airstairs2",
  "Airstairs3",
  "Catering",
  "Luggage",
  "Gas",
  "PushbackAlt",
  "Passenger",
  "Minimize",
  "Expand2",
  "ToDo",
  "Loader2",
  "Failed",
  "Done",
  "Pushback",
  "Airport",
  "LiveFill",
  "SwapBoxFill",
  "ThumbDownFill",
  "VideoAddFill",
  "SpeedUpFill",
  "Draggable",
  "FireFill",
  "MemoriesFill",
  "Scan2Fill",
  "ScanFill",
  "Watchlist1",
  "Stand",
  "Turnaround",
  "Stand2",
  "FullscreenExitFill",
  "FullscreenFill",
  "PauseCircleFill",
  "PauseFill",
  "PictureInPicture2Fill",
  "PictureInPictureExitFill",
  "Forbid",
  "SunFoggyFill",
  "MenuSearchLine",
  "Translate2",
  "LiveFill1",
  "QuestionnaireFill",
  "QuestionFill",
  "ContractLeftRightFill",
  "BaselineVideocamOff",
  "BaselinePlusMinusAlt",
  "BaselinePercentage",
  "Scales3Fill",
  "RoadMapFill",
  "TimelineView",
  "AB",
  "Ruler2Fill",
  "PassportFill",
  "GlobalLine",
  "SplitCellsHorizontal",
  "ScissorsCutFill",
  "FlagTriangle",
  "TableView",
  "ShieldCrossFill",
  "BaselineFlagFinish",
  "YoutubeFill",
  "StarFill",
  "StarLine",
  "More2Fill",
  "ArrowRightSFill",
  "SnowflakeFill",
  "WheelchairFill",
  "PassValidFill",
  "Ulds",
  "Link1",
  "AlertLine",
  "Cleaning",
  "Broom",
  "Suitcase2Fill",
  "ChargingPile2Fill",
  "LuggageCartFill",
  "Crew",
  "Chocks",
  "Door",
  "Pax",
  "MoonFoggyFill",
  "Ulds1",
  "Ulds2",
  "HighLoader",
  "BeltLoader",
  "CheckDoubleFill",
  "ArchiveDrawerFill1",
  "CheckboxMultipleFill",
  "MovieFill",
  "LiveFill2",
  "LeafFill",
  "TrafficCone",
  "VestFill",
  "AddFill",
  "Sparkling2Fill",
  "DelayFill",
  "Hourglass2Fill",
  "SlowDownFill",
  "VolumeMuteLine",
  "ChatThreadLine",
  "MegaphoneFill",
  "ChatPrivateFill",
  "ChatThreadFill",
  "InboxUnarchiveFill",
  "Upgrade",
  "Prognosis",
  "ChatVoiceFill",
  "BaseStationFill",
  "SubtractFill",
  "Scan2Line",
  "Upload2Line",
  "Download2Line",
  "SpamFill1",
  "Spam3Fill",
  "Handrails",
  "Jetbridge",
  "EngineZone",
  "Stopline",
  "PushbackAngle",
  "Wingwalker",
  "NightStick",
  "Stop",
  "RampAgent",
  "IndeterminateCircleLine",
  "TimerLine",
  "ShutDownLine",
  "SharpPendingActions",
  "GitCommitFill",
  "GitCommitLine",
  "ArrowRightWideFill",
  "ArrowRightBoxFill",
  "ArrowRightCircleFill",
  "ArrowRightDoubleFill",
  "TimerLineAlert",
  "ToysFan",
  "ChargerOutline",
  "TargetTime",
  "GateConflict",
  "GateConflictFill",
  "LineChartLine"
];
export {
  iconList
};
